import { HStack, Avatar, Text, Stack } from "@chakra-ui/react";
import { TouchableOpacity } from "components";
import { useTranslation } from "languages";
import { memo } from "react";

const QariItem: React.FC<{
  isSelected: boolean;
  isIcon?: boolean;
  qari: any;
  onCallback: () => void;
}> = ({ isSelected, qari, isIcon = true, onCallback }) => {
  const { isArabic } = useTranslation();
  return (
    <TouchableOpacity
      direction={"row"}
      bgColor={isSelected ? "primary.300" : "secondary.300"}
      borderRadius={"xl"}
      w="full"
      py={[2, 3]}
      px={[2, 4]}
      justify={"space-between"}
      align={"center"}
      onClick={onCallback}
      flexDirection={isArabic ? "row-reverse" : undefined}
    >
      <HStack gap={[2, 5]} flexDirection={isArabic ? "row-reverse" : undefined}>
        <Avatar
          name={qari?.name}
          border={`1px solid ${
            isSelected ? "white" : "var(--chakra-colors-primary-300)"
          }`}
        />
        <Text color={isSelected ? "white" : undefined}>{qari?.name}</Text>
      </HStack>
      {isIcon && (
        <Stack transform={isArabic ? "rotate(180deg)" : undefined}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 5.88 9.799"
            transform="rotate(180deg)"
          >
            <path
              id="Path_27666"
              data-name="Path 27666"
              d="M5.005,11.8a.878.878,0,0,1-.62-.252L.254,7.505a.851.851,0,0,1,0-1.214l4.13-4.042a.9.9,0,0,1,1.24,0,.851.851,0,0,1,0,1.214L2.115,6.9l3.51,3.435a.851.851,0,0,1,0,1.214A.84.84,0,0,1,5.005,11.8Z"
              transform="translate(5.88 11.799) rotate(180)"
              fill={isSelected ? "white" : "#bf8d46"}
            />
          </svg>
        </Stack>
      )}
    </TouchableOpacity>
  );
};

export default memo(QariItem);
